import React from 'react';

import { DEFAULT_ANNUAL_PRICE } from '../../src/constants';
import { CurrentOffer } from '../../utils/backend-api/groupSubscriptions';
import GiftForm from '../Settings/SettingsPage/Gift/GiftForm';
import styles from './styles.module.scss';

const LandingGiftForm = ({
  setCurrentFormStep,
  setNumberOfGifts,
  currentOffer,
}: {
  setCurrentFormStep: (setNumberOfGifts: number) => void;
  setNumberOfGifts: (numberOfGifts: number) => void;
  currentOffer: CurrentOffer;
}) => {
  return (
    <>
      <div className={styles.giftSectionHeader}>
        <div className={styles.settingsSectionHeadingText}>Gift Subscriptions</div>
        <div className={styles.settingsSectionHeadingLine}></div>
      </div>
      <div className={styles.giftSubHeader} id="GiftSubHeader">
        Give a year of The Information for ${currentOffer.initialPrice} (
        {currentOffer.discountedPercentageOff}% off) for the first year—our gift to you and your
        community. If you&rsquo;d like to extend your gift beyond one year, the subscription will
        renew at our standard rate of ${DEFAULT_ANNUAL_PRICE}.
      </div>
      <GiftForm
        forGiftLandingPage
        setCurrentFormStep={setCurrentFormStep}
        setNumberOfGifts={setNumberOfGifts}
      />
    </>
  );
};

export default LandingGiftForm;
